import React, { useCallback } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import ListItem from '@prisjakt/ui-list-item';
import { AggregationSection } from '../../../../types';
import { formatFilterValue } from './applied-filters/applied-filter';
import { ProductCollectionNonNameSearchFilter } from './types';

type Props = {
  section: AggregationSection;
  filters: ProductCollectionNonNameSearchFilter[];
  onOpen: (id: AggregationSection['id']) => void;
  disabled?: boolean;
};

const FilterSectionButton = ({ section, filters, onOpen, disabled }: Props) => {
  const { t } = useAppContext();
  const onClick = useCallback(() => onOpen(section.id), [section, onOpen]);
  const filter = filters.find(({ property }) => property === section.property);

  return (
    <ListItem
      key={section.id}
      name={section.title}
      callToActionText={filter && formatFilterValue(filter, t)}
      showArrow
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default FilterSectionButton;
